<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog
        content-class="filter-3p"
        v-model="filtersPopup"
        persistent
        max-width="1224px"
      >
        <v-card class="filter_ui">
          <v-card-actions>
            <v-row class="pa-2">
              <v-col>
                <v-menu
                  ref="menu_16"
                  v-model="menu_16"
                  :close-on-content-click="false"
                  :return-value.sync="filter_date"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ props }">
                    <v-text-field
                      variant="outlined"
                      v-model="selected_filter_date"
                      label="Date"
                      prepend-inner-icon="mdi-calendar"
                      color="blue"
                      readonly
                      v-bind="props"
                      class="ma-2"
                    ></v-text-field>
                  </template>
                  
                  <v-card class="m-0 overflow-hidden calendar-layout">
                  <v-date-picker v-model="isDatePickerDate" hide-header scrollable
                  @update:modelValue="handleClickOnDate" 
                  color="primary"
                  min-width="100"
                  max-width="300"
                  >
                  </v-date-picker>
                  <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                    <v-btn variant="outlined" color="black" @click="menu_16 = false" class="text-none"

                      >Cancel</v-btn
                    >
                    <v-btn
                      variant="text"
                      color="primary"
                      class="text-none"
                      @click="handleSaveDate"
                      >Ok</v-btn
                    >
                  </v-card-action>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col v-if="active_tab == 'Recovery'">
                <v-combobox
                  color="primary"
                  v-model="filterStage"
                  :items="stages_data"
                  item-title="name"
                  item-value="id"
                  label="Stage"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
              <v-col>
                <!-- <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    v-model="search_vendor"
                    label="vendor"
                    style="max-width:
                    300px;" outlined
                    class="ma-2"
                ></v-text-field> -->
                <v-combobox
                  color="primary"
                  v-model="search_vendor"
                  :items="search_vendor_data"
                  item-title="vendor_name"
                  item-value="vendor_code"
                  label="vendor"
                  variant="outlined"
                  class="ma-2"
                  @keyup="handleKeyEnter($event)"
                ></v-combobox>
              </v-col>
              <v-col v-if="active_tab == 'Recovery'">
                <v-combobox
                  color="primary"
                  v-model="filterType"
                  :items="date_type"
                  item-title="name"
                  item-value="id"
                  label="Type"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
              <v-col v-if="active_tab == 'Cost'">
                <v-combobox
                  color="primary"
                  v-model="filterCostType"
                  :items="cost_data_type"
                  item-title="name"
                  item-value="id"
                  label="Cost Type"
                  variant="outlined"
                  class="ma-2"
                ></v-combobox>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" variant="text" color="normal" @click="cancelFilterpopup"
              >Cancel</v-btn
            >
            <v-btn size="small" variant="flat" class="text-none" color="primary" @click="applyFilterFunc()" >Apply Filter(S)</v-btn >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Update CN/DN number popup -->
    <v-row justify="center">
      <v-dialog v-model="updateCNorDNPopup" persistent max-width="366px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Update</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="updateCNorDNPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
            <v-card-text>
              <v-container>
              <v-row v-for="(row, index) in cn_dns" :key="index">
                  <v-text-field
                    color="primary"
                    label="CN/DN Note Number"
                    variant="outlined"
                    v-model="row.cn_dn_number"
                    required
                    @input="sanitizeInput"
                    width="100%"
                    :disabled="row.isDisabled"
                  ></v-text-field>
                  <v-text-field
                    color="primary"
                    label="Enter Amount (₹)"
                    variant="outlined"
                    v-model="row.amount"
                    required
                    width="100%"
                    @input="formatIndianCurrency(index)"
                    :disabled="row.isDisabled"
                  ></v-text-field>
                </v-row>
              </v-container>
                  <span style="cursor: pointer; color: #0357D0;" @click="addMore"><v-icon color=" mr-1" size="small">mdi-plus</v-icon>Add More</span>
            </v-card-text>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn
                variant="outlined"
                class="cancel-color mb-3 text-none"
                @click="updateCreditNumberSubmit('save')"
                :disabled="!buttonDisabled()"
                >Submit & Save</v-btn
              >
              <v-btn
                color="primary"
                class="mb-3 text-none"
                variant="flat"
                @click="updateCreditNumberSubmit('close')"
                :disabled="!buttonDisabled()"
                >Submit & Close</v-btn
              >           
              <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Edit Amount popup -->  
    <v-row justify="center">
      <v-dialog v-model="editamountpopup" persistent max-width="366px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0">
            <v-card-title class="d-flex">
              <v-row class="ma-1">
              <span>Edit Amount</span>
              <v-spacer></v-spacer>
                <v-icon  @click="editamountpopup = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
          </v-card>
            <v-card-text>
              <v-container>
                  <v-col cols="6" sm="12" md="12" style="height: 96px;">
                    <v-text-field label="Enter Amount(₹)" variant="outlined" v-model="format_amount" type="text" required oninput="this.value = this.value.replace(/[^0-9]/g, '');"></v-text-field>
                    </v-col>               
              </v-container>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="updateAmount" :disabled="!edit_amount && edit_amount !== 0">Submit</v-btn>
            <v-btn variant="outlined" class="cancel-color mb-3 text-none" @click="editamountpopup = false">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="sussesspopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="sussesspopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text
            class="text-center"
            v-if="active_tab == 'Recovery' || active_tab == 'Cost'"
          >
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData"
              >Ok</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Item data detail popup for recovery-->
    <v-row justify="center">
      <v-dialog v-model="datadetailpopup" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="datadetailpopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500">Date</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{
                      item_details.formatted_date
                        ? item_details.formatted_date
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col colo="6" sm="6" md="6">
                    <span style="font-weight: 600"> Stage</span>
                  </v-col>
                  <v-col colo="12" sm="6" md="6">
                    {{
                      item_details.formatted_stage_name
                        ? item_details.formatted_stage_name
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Vendor</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.vendor_name
                        ? item_details.vendor_name
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Type</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.formatted_note_type
                        ? item_details.formatted_note_type
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Approval Ref. NO.</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.approval_reference_number
                        ? item_details.approval_reference_number
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Amount</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.claim_amount
                        ? item_details.claim_amount
                        : "-"
                    }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Item data detail popup for cost-->
    <v-row justify="center">
      <v-dialog v-model="datadetailcostpopup" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="datadetailcostpopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500">Repair Cost</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{
                      item_details.claim_amount
                        ? item_details.claim_amount
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col colo="6" sm="6" md="6">
                    <span style="font-weight: 600"> Cost Type</span>
                  </v-col>
                  <v-col colo="12" sm="6" md="6">
                    {{
                      item_details.formatted_cost_type
                        ? item_details.formatted_cost_type
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Approval Ref. NO.</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.approval_reference_number
                        ? item_details.approval_reference_number
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Date</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.formatted_date
                        ? item_details.formatted_date
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Vendor</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.vendor_name
                        ? item_details.vendor_name
                        : "-"
                    }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Item data detail popup for closed-->
    <v-row justify="center" v-if="tabNameData == 'Cost'">
      <v-dialog
        v-model="datadetailcostpopupclosed"
        persistent
        max-width="700px"
      >
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="datadetailcostpopupclosed = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500">Date</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{
                      item_details.formatted_date
                        ? item_details.formatted_date
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col colo="6" sm="6" md="6">
                    <span style="font-weight: 600"> Repair Cost</span>
                  </v-col>
                  <v-col colo="12" sm="6" md="6">
                    {{
                      item_details.claim_amount
                        ? item_details.claim_amount
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Cost Type</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.formatted_cost_type
                        ? item_details.formatted_cost_type
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Approval Ref. NO.</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.approval_reference_number
                        ? item_details.approval_reference_number
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Vendor</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.vendor_name
                        ? item_details.vendor_name
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">CN/DN Number</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.credit_debit_note_number
                        ? item_details.credit_debit_note_number
                        : "-"
                    }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center" v-if="tabNameData == 'Recovery'">
      <v-dialog
        v-model="datadetailcostpopupclosed"
        persistent
        max-width="700px"
      >
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="datadetailcostpopupclosed = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500">Date</span>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    {{
                      item_details.formatted_date
                        ? item_details.formatted_date
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col colo="6" sm="6" md="6">
                    <span style="font-weight: 600"> Stage</span>
                  </v-col>
                  <v-col colo="12" sm="6" md="6">
                    {{
                      item_details.formatted_stage_name
                        ? item_details.formatted_stage_name
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Vendor</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.vendor_name
                        ? item_details.vendor_name
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Type</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.formatted_note_type
                        ? item_details.formatted_note_type
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Approval Ref. No.</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.approval_reference_number
                        ? item_details.approval_reference_number
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">CN/DN Number</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.credit_debit_note_number
                        ? item_details.credit_debit_note_number
                        : "-"
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600">Amount</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    {{
                      item_details.claim_amount
                        ? item_details.claim_amount
                        : "-"
                    }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!--delete  -->
    <v-row justify="center">
      <v-dialog v-model="deleteDialog" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title>         
            <v-row class="p-2">
             <span>Delete</span>
            <v-spacer></v-spacer>
            <!-- <v-btn icon  > -->
              <v-icon @click="deleteDialog = false">mdi-close</v-icon>
            <!-- </v-btn> -->
            </v-row>
          </v-card-title>
          <v-container>
            <v-row  class="p-3 text-center">
            <v-text-field v-model="remarks" label="Remarks" variant="outlined"></v-text-field>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn small variant="outlined" class="text-none" color="primary" @click="deleteDialog = false">Cancel</v-btn>
            <v-btn small variant="flat" class="text-none" color="primary" :disabled="!remarks" @click="deleteItem">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Download popup -->
    <v-row justify="center">
      <v-dialog v-model="downloadDialog" persistent max-width="364px">
        <v-card class="v-card-100">
        <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span class="font-weight-bold pl-2">Download</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="downloadDialog = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
            <v-card-text class="download-email mt-2">
              <v-row>
                <v-col cols="12" sm="4" md="12">
                  <v-text-field label="Email Id" :rules="emailRules" @input="validateEmail" variant="outlined"  v-model="email_id" type="text"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="text-none" size="large" color="primary" @click="downloadDialog = false">Cancel</v-btn>
            <v-btn variant="flat" class="text-none" size="large" color="primary" @click="downloadFile('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- For showing tabs -->
    <v-card class="v-card-100">
      <v-tabs v-model="tab_index" color="primary">
        <v-tab
          ripple
          style="text-transform: none !important"
          @click="loadData(tab, 'tab_clicked')"
          v-for="(tab, index) in tabs"
          :key="index"
          >{{ tab }}</v-tab
        >
      </v-tabs>
    </v-card>
    <!-- For showing Filters and Action buttons -->
    <v-card-title class="action-style pb-4" style="padding: 25px;">
     <v-row>
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="item_search"
            v-no-edge-space
            label="Search"
            color="blue"
            style="max-width: 300px"
            variant="outlined"
            v-on:keyup.enter="loadData(active_tab)"
          ></v-text-field>  
      <v-spacer></v-spacer>
      <v-card-actions style="display: flex;" v-if="active_tab !== 'Closed'">
          <v-menu offset-y>
               <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-2 px-5" size="x-large">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in actionList" :key="index" :disabled="isActionDisabled(item)">
                    <v-list-item-title style="cursor: pointer;" @click="updateAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
       </v-card-actions>

      <template v-if="active_tab != 'Closed' && isActionAllowed(role)">
        <v-expansion-panels
          ref="filterPopupRef"
          class="custom-control_outlined filter-panels-btn  m-0 pt-5 mr-2"
          readonly
          style="max-width: 300px;margin-bottom: 14px; height: 52px;"
        >
          <v-expansion-panel @click="listFiltersData">
            <v-expansion-panel-title
              >Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </v-row>
    </v-card-title>
    <!-- List data -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table 
          hover
          v-if="active_tab != 'Closed'"
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="computedHeaders"
          :items="table_data"
          :items-per-page="pageSize"
          :loading="loading"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
        >
        <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in computedHeaders">
              <span v-if="headers.key == 'tag_number'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.tag_number }}</a>
              </span>
             <span v-else-if="headers.key == 'claim_amount'">
                <span>{{ item.claim_amount !== null && item.claim_amount !== undefined ? item.claim_amount.toLocaleString('en-IN') : '' }}</span>
              </span>
              <span v-else-if="headers.key !== 'images' && item[headers.key]">
                <span v-tooltip="item[headers.key]">
                  {{ item[headers.key].length > 20 ? item[headers.key].slice(0, 20) + '...' : item[headers.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template #[`item.tag_number`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2" class="cursor-pointer">
              <u> {{ item.tag_number }}</u>
            </a>
          </template> -->
          <!-- <template #[`item.claim_amount`]="{ item }">
            <span>{{ item.claim_amount ? item.claim_amount.toLocaleString('en-IN') : '' }}</span>
          </template> -->
          <!-- <template #[`item.approval_reference_number`]="{ item }">
            <span>{{ item.approval_reference_number ? item.approval_reference_number: '-' }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
        <!-- closed list data -->
        <v-data-table 
          hover
          v-if="active_tab == 'Closed'"
          density="compact"
          :search="search"
          v-model="selected"
          disable-pagination
          :hide-default-footer="true"
          :headers="computedHeaders"
          :items="table_data"
          :items-per-page="pageSize"
          :loading="loading"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
        >
        <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in computedHeaders">
              <span v-if="headers.key == 'tag_number'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.tag_number }}</a>
              </span>
              <span v-else-if="headers.key == 'claim_amount'">
                <span>{{ item.claim_amount ? item.claim_amount.toLocaleString('en-IN') : '' }}</span>
              </span>
              <span v-else-if="headers.key == 'settled_amount'">
                <span>{{ item.settled_amount ? item.settled_amount.toLocaleString('en-IN') : '' }}</span>
              </span>
              <span v-else-if="headers.key !== 'images' && item[headers.key]">
                <span v-tooltip="item[headers.key]">
                  {{ item[headers.key].length > 20 ? item[headers.key].slice(0, 20) + '...' : item[headers.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>

          <!-- <template #[`item.tag_number`]="{ item }">
            <a @click="itemDetailpopup(item)" style="color: #1976d2" class="cursor-pointer">
              <u> {{ item.tag_number }}</u>
            </a>
          </template>
          <template #[`item.claim_amount`]="{ item }">
            <span>{{ item.claim_amount ? item.claim_amount.toLocaleString('en-IN') : '' }}</span>
          </template> -->
          <!-- <template #[`item.approval_reference_number`]="{ item }">
            <span>{{ item.approval_reference_number ? item.approval_reference_number: '-' }}</span>
          </template> -->
          <!-- <template #[`item.credit_debit_date`]="{ item }">
            <span>{{ item.credit_debit_date ? item.credit_debit_date: '-' }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!-- pagination -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>

import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { mixinHelper } from "@//mixins/mixin-helper.js"; 
import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
// import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';

export default {
  mixins: [mixinHelper], 
  data() {
    return {
      headerText: "3P Claim",
      loading: false,
      alert: false,
      alert_type: "success",
      alert_message: "success",
      active_tab: "Recovery",
      tab_name: "Recovery",
      tabs: ["Recovery", "Cost", "Closed"],
      headers: [
        {
          title: "Tag ID",
          key: "tag_number"
          ,minWidth:"200px" ,
          align: "start",
          sortable: false,
        },
        { title: "Date", key: "formatted_date",minWidth:"200px" },
        { title: "Stage", key: "formatted_stage_name",minWidth:"200px"  },
        { title: "Vendor", key: "vendor_name",minWidth:"200px"  },
        { title: "Type", key: "formatted_note_type",minWidth:"200px"  },
        { title: "Approval Ref. No.", key: "approval_reference_number",minWidth:"200px"  },
        { title: "Amount(₹)", key: "claim_amount",minWidth:"200px"  },
      ],
      table_data: [],
      totalCount: '',
      page: 1,
      totalPages: 1,
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      item_search: "",
      filtersPopup: false,
      filterStage: null,
      search_vendor: null,
      filterType: null,
      filter_date: "",
      isDatePickerDate: new Date(),
      filterCostType: null,
      menu_16: false,
      selected: [],
      updateCNorDNPopup: false,
      credit_note_number: "",
      sussesspopup: false,
      datadetailpopup: false,
      item_details: [],
      tag_number: "",
      ins_id: "",
      item_id: "",
      successmessage: "",
      stages_data: "",
      date_type: "",
      cost_data_type: "",
      search_vendor_data: "",
      datadetailcostpopup: false,
      datadetailcostpopupclosed: false,
      search: "",
      tabNameData: "",
      isFilteringPage: false,
      filterPageNo : 1,
      organization_name:'',
      editamountpopup:false,
      edit_amount:'',
      tab_index: 0,
      role:'',
      deleteDialog:false,
      remarks:'',
      actionList: [],
      select_field: null,
      downloadDialog:false,
      email_id:'',
      isEmailValid:true,
      emailError:'',
      select_field_items: ['Tag ID','IRD','Lot ID','Publish ID'],
      cn_dns:[
          {
            cn_dn_number:'',
            amount:''
          }
        ]
    };
  },
  components: {
    HeaderComponent,
  },
  computed:{    
    selected_filter_date() {
     return this.filter_date
    },
    emailRules() {
        return [
          v => this.emailError || true
        ];
      },    
  },
  async created() {
    this.organization_name = this.$store.state.organization_name;
    this.active_tab_condi = this.$store.state.active_tab;
    const tab = this.$store.state.active_tab
    this.role = this.$store.state.currentUser.roles[0]
    if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Claim Tracking')){
      signout()
      return;
    }
    if(this.active_tab_condi === 'first_tab' || tab == 'Recovery'){
        this.tab_index = 0;
        this.loadData('Recovery');
      }else if(this.active_tab_condi === 'second_tab' || tab == 'Cost'){
        this.tab_index = 1;
        this.loadData('Cost');
      }else if(this.active_tab_condi === 'third_tab' || tab == 'Closed'){
        this.tab_index = 2;
        this.loadData('Closed');
      }else{
        this.loadData('Recovery')
      }
    },
  computed: {
    computedHeaders() {
      if (this.$isRelianceClient()) {
        return this.headers;
      } else {
        return this.headers.filter(header => header.value !== 'serial_number' && header.value !== 'ird_number');
      }
    },
    format_amount : {
        get() {
        return this.edit_amount !== '' && this.edit_amount !== null && this.edit_amount !== undefined
          ? this.formatCurrency(this.edit_amount)
            : "";
        },
        set(value) {
        const cleaned = value.replace(/[^0-9.-]+/g, '');
        if (cleaned === '') {
          this.edit_amount = '';
        } else {
          const numericValue = Number(cleaned);
          this.edit_amount = isNaN(numericValue) ? '' : numericValue;
        }
      }        
    },
    emailRules() {
        return [
          v => this.emailError || true
        ];
      }
  },
  methods: {   
    isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Claim Tracking')
      },
    formatCurrency(value) {
      let number = typeof value === 'string' ? value.replace(/,/g, '') : value
      return Number(number) || Number(number) === 0 ?  Number(number).toLocaleString('en-IN') : null;
    },
    formatNumber(value){
      return typeof value === 'string' ? Number(value.replace(/,/g, '')) : value
    },
    handleSaveDate(){
      this.menu_16 =  false
    },

    handleClickOnDate(value){
      // this.filter_date = year + "-" + month + "-" + date
           this.filter_date = this.formatted_filter_date(value)
    },
    listFiltersData(ev) {
      document.documentElement.style.setProperty( "--dialog-ypos", ( this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 10 ).toString() + "px", );
      this.item_search = "";
      this.filtersPopup = true;
      this.filter_date = '';
      this.filterCostType = null;
      this.search_vendor = null;
      this.filterType = null;
      this.filterStage = null;
    },
    getRequestParams(page, pageSize, filterPageNo) {
      let params = {};

      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (filterPageNo) {
        params["filterPageNo"] = filterPageNo
      }
      return params;
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    loadData(tab, tab_action) {
      if (tab_action) {
        this.item_search = "";
      }
      this.$store.commit('setActiveTab',{ 'active_tab' : tab});
      this.loading = true;
      this.selected = [];
      this.active_tab = tab;
      this.table_data = [];
      this.page = 1;
      this.totalPages = 1;
      this.filterPageNo = 1
      this.isFilteringPage = false
      if (tab == "Recovery") {
        this.actionList = ["Update CN/DN Number", "Upload", "Download", "Delete"];
        this.headers = [
          {
            title: "Tag ID",
            key: "tag_number"
            ,minWidth:"200px", 
            align: "start",
            sortable: false,
          },
          { title: "Claim Tracking Number", key: "claim_tracking_number",minWidth:"200px"  },
          { title: "Date", key: "formatted_date",minWidth:"200px"  },          
          { title: "Stage", key: "formatted_stage_name",minWidth:"200px"  },
          { title: "Vendor", key: "vendor_name",minWidth:"200px"  },
          { title: "Type", key: "formatted_note_type",minWidth:"200px",minWidth:"200px"   },
          { title: "Approval Ref. No.", key: "approval_reference_number",minWidth:"200px"  },
          { title: "Amount(₹)", key: "claim_amount",minWidth:"200px"  },
          { title: "Pending Amount(₹)", key: "balance_amount",minWidth:"200px" },
          { title: "Serial Number", key: "serial_number",minWidth:"200px" },
          { title: "IRD Number", key: "ird_number",minWidth:"200px" }
        ];
        this.fetchingRecoveryData();
        this.fetchingFiltersData();
      }
      if (tab == "Cost") {
        this.actionList = ["Update CN Number", "Upload", "Download"];
        this.headers = [
          {
            title: "Tag ID",
            key: "tag_number"
            ,minWidth:"200px" ,
            align: "start",
            sortable: false,
          },
          { title: "Date", key: "formatted_date",minWidth:"200px"  },
          { title: "Cost (₹)", key: "claim_amount",minWidth:"200px"  },
          { title: "Cost Type", key: "formatted_cost_type",minWidth:"200px"  },
          { title: "Approval Ref. No.", key: "approval_reference_number",minWidth:"200px"  },
          { title: "Vendor", key: "vendor_name",minWidth:"200px"  },
          { title: "Serial Number", key: "serial_number",minWidth:"200px" },
          { title: "IRD Number", key: "ird_number",minWidth:"200px" }
        ];
        this.fetchingRecoveryData();
        this.fetchingFiltersData();
      }
      if (tab == "Closed") {
        this.headers = [
          {
            title: "Tag ID",
            key: "tag_number",
            minWidth:"200px" ,
            align: "start",
            sortable: false,
          },
          { title: "Date", key: "credit_debit_date",minWidth:"200px"  },
          { title: "Vendor", key: "vendor_name",minWidth:"200px"  },
          { title: "Type", key: "formatted_note_type",minWidth:"200px"  },
          { title: "Approval Ref. No.", key: "approval_reference_number",minWidth:"200px"  },
          { title: "CN/DN Number", key: "credit_debit_note_number",minWidth:"200px"  },
          { title: "Amount(₹)", key: "claim_amount",minWidth:"200px"  },
          { title: "Final Amount(₹)", key: "settled_amount",minWidth:"200px"  },
          { title: "Serial Number", key: "serial_number",minWidth:"200px" },
          { title: "IRD Number", key: "ird_number",minWidth:"200px" }
        ];
        this.fetchingRecoveryData();
      }
    },
    fetchingRecoveryData() {
      const params = this.getRequestParams(this.page, this.pageSize);
      const requestParams = {
        page: params.page,
        per_page: params.size,
        tab: this.active_tab,
        // claim_raised_date: this.filter_date,
        // // vendor_code: this.search_vendor.vendor_code,
        // stage_name: this.filterStage.id,
        // note_type: this.filterType.id,
        // cost_type: this.filterCostType.id,
      };
      // Add the search parameter based on the organization
      if (this.$isRelianceClient()) {
        requestParams.search = this.item_search;
      } else {
        requestParams.tag_number = this.item_search;
      }
      this.$httpSecured
        .get("/api/v1/warehouse/third_party_claims", {params: requestParams})
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.third_party_claims;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.filter_date = "";
            this.isDatePickerDate = new Date()
            this.filterCostType = null;
            this.search_vendor = null;
            this.filterType = null;
            this.filterStage = null;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    handlePageChange(value) {
      this.page = value;
      if(this.isFilteringPage){
        this.filterPageNo = value;
        this.applyFilterFunc()
        return;
      }
      this.fetchingRecoveryData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.filterPageNo = 1;
      if(this.isFilteringPage){
        this.applyFilterFunc();
        return;
      }
      this.fetchingRecoveryData();
    },
    applyFilterFunc() {
      this.isFilteringPage = true
      const params = new URLSearchParams();
      const filterData = this.filter_date ? this.filter_date : ''
      const vendorCode = this.search_vendor ? this.search_vendor.vendor_code : ''
      const filterStage = this.filterStage ? this.filterStage.id : ''
      const filterType = this.filterType ? this.filterType.id : ''
      const filterCostType = this.filterCostType ? this.filterCostType.id : ''
      params.append('page', this.filterPageNo)
      params.append('per_page', this.pageSize)
      params.append('tag_number', this.item_search)
      params.append('claim_raised_date', filterData)
      params.append('vendor_code', vendorCode)
      params.append('stage_name', filterStage)
      params.append('note_type', filterType)
      params.append('cost_type', filterCostType)
      params.append('tab', this.active_tab)
      if (this.active_tab == "Recovery" || this.active_tab == "Cost") {
        this.loading = true;
        this.$httpSecured
        .get("/api/v1/warehouse/third_party_claims", {params})
        .then(response => {
          if (response.data) {
            this.table_data = response.data.third_party_claims
            this.totalPages = response.data.meta.total_pages
            this.totalCount = response.data.meta.total_count
            this.filtersPopup = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
      }
    },
    fetchingFiltersData() {
      this.$httpSecured
        .get("/api/v1/warehouse/third_party_claims/get_filters_data")
        .then((response) => {
          if (response.data) {
            if(this.active_tab === 'Recovery'){
              this.stages_data = response.data.stage_names.filter(stage => stage.name !== 'Repair cost');
            }
            this.date_type = response.data.note_types;
            this.cost_data_type = response.data.cost_types;
            this.search_vendor_data = response.data.vendors_data;
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    afterClickOkLoadData() {
      this.sussesspopup = false;
      this.selected = [];
      this.loadData(this.active_tab);
    },
    updateDialogRecovery(){
      this.credit_note_number = '';
      if (this.selected.length && this.selected[0].cn_dn_details.length > 0) {        
        this.cn_dns = this.selected[0].cn_dn_details.map(item => ({
            cn_dn_number: item.cn_dn_number,
            amount: item.amount,
            isDisabled: true
          }));

      } else {
        this.cn_dns = [
          {
            cn_dn_number:'',
            amount:'',
            isDisabled: false 
          }
        ];
        this.enabled_feilds = false;
      }
      this.updateCNorDNPopup = true;
      this.ins_id = this.selected.map((insurances) => insurances.id);
    },
    itemDetailpopup(item) {
      if (this.active_tab == "Recovery") {
        this.datadetailpopup = true;
        this.tag_number = item.tag_number;
        let str = String(this.tag_number);
        this.tag_number = str;
        this.item_id = item.id;
        this.$httpSecured
          .get(`/api/v1/warehouse/third_party_claims/${this.item_id}`)
          .then((response) => {
            if (response.data) {
              this.item_details = response.data.third_party_claim;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
      }
      if (this.active_tab == "Cost") {
        this.datadetailcostpopup = true;
        this.tag_number = item.tag_number;
        let str = String(this.tag_number);
        this.tag_number = str;
        this.item_id = item.id;
        this.$httpSecured
          .get(`/api/v1/warehouse/third_party_claims/${this.item_id}`)
          .then((response) => {
            if (response.data) {
              this.item_details = response.data.third_party_claim;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
      }
      if (this.active_tab == "Closed") {
        this.datadetailcostpopupclosed = true;
        this.tag_number = item.tag_number;
        let str = String(this.tag_number);
        this.tag_number = str;
        this.item_id = item.id;
        this.$httpSecured
          .get(`/api/v1/warehouse/third_party_claims/${this.item_id}`)
          .then((response) => {
            if (response.data) {
              this.item_details = response.data.third_party_claim;
              this.tabNameData = response.data.third_party_claim.tab_name;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
      }
    },
    updateCreditNumberSubmit(type) {
      console.log(JSON.stringify(this.cn_dns));
        const filtered_cn_dns = this.cn_dns.filter(item => !item.isDisabled).map(item => ({
          ...item,
        amount: item.amount.toString().replace(/,/g, '')
        }));
      var ids = [];
      ids = this.ins_id;
      this.$httpSecured
        .put(`/api/v1/warehouse/third_party_claims/update_cn_dn_number`, {
          ids: ids,
          cn_dns: filtered_cn_dns,
          action_type: type
        })
        .then((response) => {
          if (response.data) {
            this.updateCNorDNPopup = false;
            this.sussesspopup = true;
            this.successmessage = response.data.message;
            this.credit_note_number = "";
            this.showAlert("success", "Successfully updated");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network");
          this.number = 0;
          this.loading = false;
        });
    },
    cancelFilterpopup() {
      this.filtersPopup = false;
      this.filter_date = "";
      this.isDatePickerDate = new Date(),
      this.filterCostType = null;
      this.search_vendor = null;
      this.filterType = null;
      this.filterStage = null;
    },
    handleKeyEnter(event) {
      this.fetchVendorData(event.target.value);
    },
    fetchVendorData(val) {
      this.$httpSecured
        .get("/api/v1/warehouse/new_repairs/get_vendor_master", {
          params: {
            query: val,
          },
        })
        .then((response) => {
          if (response.data) {
            this.search_vendor_data = response.data.vendor_masters;
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    openEditAmountPopup(){
      this.ins_id = this.selected.map(insurances => insurances.id);
      this.editamountpopup = true;
      this.edit_amount = this.selected[0].claim_amount;
    },
    updateAmount(){
      var ids = [];
      ids = this.ins_id
      this.$httpSecured.put(`/api/v1/warehouse/third_party_claims/update_amount`, {
            "ids":ids,
            "claim_amount": this.formatNumber(this.edit_amount)
          }
        )
        .then(response => {
          if (response.data) {
            this.editamountpopup = false;
            this.edit_amount = '';
            this.sussesspopup = true;
            this.successmessage = response.data
            this.showAlert("success", "Successfully updated");
            this.loadData(this.active_tab);
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", "Something went wrong from Network");
          this.number = 0;
          this.loading = false;
        });
    },
    downloadInventory() {
        let ids = this.selected.map(inward => inward.id);
        this.$httpSecured.post(`/api/v1/warehouse/third_party_claims/download`,{
          'ids': ids
        })
          .then(response => {
            const link = document.createElement('a');
            link.href = response.data.url; 
            link.target = '_blank';
            link.download = 'inventory.csv'; 
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.sussesspopup = true;
            this.successmessage = "Successfully downloaded"
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      navigateToFileUpload() {
        if(this.active_tab === 'Recovery'){
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: this.active_tab,
            action:'first_tab'
          });
        }else if(this.active_tab === 'Cost'){
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: this.active_tab,
            action:'second_tab'
          });
        }
      this.$router.push({ name: "LotFileuploadComm" });
    },
    sanitizeInput(event) {
      this.credit_note_number = this.credit_note_number.replace(/[^0-9],/g, "");
    },
    openDeletePopup(){
      this.deleteDialog = true
    },
    deleteItem() {
      var dc = this.selected.map(x => x.id).join(',');
      const params = new URLSearchParams({
        remarks: this.remarks,
      });
      this.$httpSecured
        .delete(`/api/v1/warehouse/third_party_claims/${dc}?${params.toString()}`)
        .then(response => {
          if (response.data) {
            this.deleteDialog = false;
            this.sussesspopup = true;
            this.successmessage = response.data.message;
            this.remarks = '';
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    isActionDisabled(item) {
       if (item === 'Download') {
          return false;
        }
        if (item === 'Upload') {
          return (item == 'Upload' && this.selected.length != 0);
        }
        return this.selected.length === 0;
    },
    updateAction(item) {
      if(item == 'Update CN/DN Number' || item == 'Update CN Number'){
         this.updateDialogRecovery();
      } else if(item == 'Upload'){
        this.navigateToFileUpload();
      }else if(item == 'Download'){
        if(this.selected.length > 0){          
          this.downloadInventory();
        }else{
          this.openPopup()
        }
      }else if(item == 'Delete'){
        this.openDeletePopup();
      }
    },
    openPopup(){
        this.downloadDialog = true;
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id)
      },
      validateEmail() {
        const emails = this.email_id.split(',').map(email => email.trim());
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emails.length === 1 && !emailPattern.test(emails[0])) {
          this.emailError = 'Please enter a valid email';
          this.isEmailValid = false
          return;
        }else{
          this.isEmailValid = true
        }

        for (const email of emails) {
          if (!emailPattern.test(email)) {
            this.emailError = 'Please enter valid email ids separated by commas';
            this.isEmailValid = false
            return;
          }else{
            this.isEmailValid = true
          }
        }     

        this.emailError = null;
      },
     buttonDisabled() {
      const disabledCondi = [... new Set(this.cn_dns.map(row => row.isDisabled))];
      if(disabledCondi.length == 1 && disabledCondi[0] == true){
        return false
      }else if (disabledCondi.length > 1) {
        return this.cn_dns.every(row => row.cn_dn_number && row.amount);
      }else{
        return this.cn_dns.every(row => row.cn_dn_number && row.amount);
      }
      
    },
    addMore() {
        this.cn_dns = [
          ...this.cn_dns,
            {
              cn_dn_number: "",
              amount: '',
              isDisabled: false
            }
          ];
      },
       formatIndianCurrency(index) {
        let value = this.cn_dns[index].amount;
        value = value.toString().replace(/[^0-9.]/g, '');
        const [intPart, decimalPart] = value.split('.');
        const lastThree = intPart.slice(-3);
        const otherNumbers = intPart.slice(0, -3);
        const formatted = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + (otherNumbers ? "," : "") + lastThree;
        this.cn_dns[index].amount = decimalPart ? `${formatted}.${decimalPart}` : formatted;
      },
      downloadFile(value) { 
        this.number++;
        const formData = new FormData();
          formData.append('email_ids', this.email_id);
          formData.append('tab', this.active_tab);       
         let url = "/api/v1/warehouse/third_party_claims/download"
        this.$httpSecured
          .post(url, formData)
          .then(response => {
              if (response.data) {              
                  this.selected = [];
                  this.downloadDialog = false
                  this.sussesspopup = true;
                  let msg = response.data.message; 
                  const match = msg.match(/\[(.*?)\]/);
                  const emails = JSON.parse("[" + match[1] + "]");
                 this.successmessage = `Download link will be sent to you on ${emails.join(", ")}`;
                  this.number = 0;
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                  this.number = 0;
              }
          })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
      },
  },
};
</script>
<style scoped>
.v-dialog:has(.filter-3p) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}

.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 308px) !important;
} 
.filter_ui{
  margin-left: 25px !important;
  margin-top: 45px !important;
}
</style>
